import React from 'react';

function None404({history}) {

  // const goBack = () => {
  //   history.goBack();
  // };

        return (
          <section className="none404">
            <div className="alertWrap">
              <h2>404 error</h2>
              <p>페이지가 존재하지 않거나, 사용할 수 없는 페이지입니다.</p>
              <p>입력하신 주소가 정확한지 다시한번 확인해 주시기 바랍니다.</p>

              {/*<button className="btnSec mgr-8" onClick={goBack}>이전 페이지로 돌아가기</button>*/}
              {/*<button className="btnPrm">홈 바로가기</button>*/}
            </div>
          </section>
        );
}

export default None404;
